import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// import { FiChevronRight } from "react-icons/fi";
import { postToApp, addAppMessageListener } from "../../bridges/appBridge";
import Popup from "../../assets/components/PopupGroup";
import { TwinColumn } from "../../assets/components/ButtonGroup";
import right_gray from "../../assets/icons/Chevron/right_disabled.svg";
import right from "../../assets/icons/Chevron/right_black.svg";
import VersionInfo from "./components/VersionComponents/VersionInfo";
import kakao from "../../assets/image/login/kakao_icon.svg"
import google from "../../assets/image/login/google_icon.svg";
import apple from "../../assets/image/login/apple_icon.svg";
import coin from "../../assets/icons/Token/Coin.svg"
import { HeaderIconL } from "../../assets/components/HeaderGroup";
import { useFixedLayout } from "../../hooks/useFixedLayout";
import { fetchSiksinMenusByBusinessNumber } from "../../utils/siksinMenus";
import { getEffectiveRepresentativeMenus } from "../../utils/representativeMenus";
import { fetchConciergeImagesByBusinessNumber } from "../../utils/conciergeImages";

const MyPage = ({ data }) => {
    const navigate = useNavigate();
    const roadName = data?.road_name ?? "";
    const business_name = data?.business_name ?? "";
    const storeBusinessNumber = localStorage.getItem("store_business_number")
    const userId = localStorage.getItem("user_id")
    const login_provider = localStorage.getItem("login_provider")

    // 상단 고정
    const { headerRef, headerSpace } = useFixedLayout();

    const tab = "mypage"
    const from = "direct"

    const loginLabel = ({
        local: "로컬로",
        apple: "애플로",
        kakao: "카카오톡으로",
        google: "구글로",
    })[login_provider];

    const loginIcons = {
        kakao: kakao,
        google: google,
        apple: apple,
    };

    const loginIconSrc = loginIcons[login_provider];

    const [info, setInfo] = useState({})
    const [, setRecords] = useState([]);
    const [ticketInfo, setTicketInfo] = useState([]);
    const [logoutOpen, setLogoutOpen] = useState(false);
    const [appVersion, setAppVersion] = useState("v0.00.00");
    const [registerTag, setRegisterTag] = useState("")
    const [representativeTop3, setRepresentativeTop3] = useState([]);


    const saveMyPageScrollTarget = (targetId) => {
        try {
            sessionStorage.setItem("mypage_scroll_target", targetId);
        } catch (e) {
            console.warn("saveMyPageScrollTarget 실패:", e);
        }
    };

    useEffect(() => {
        try {
            const targetId = sessionStorage.getItem("mypage_scroll_target");
            if (!targetId) return;

            const el = document.getElementById(targetId);
            if (!el) return;

            // 스크롤 실제로 이동
            el.scrollIntoView({ block: "start", behavior: "auto" });
        } catch (e) {
            console.warn("restore scroll 실패:", e);
        }
        sessionStorage.removeItem("mypage_scroll_target");
    }, []);



    // 앱버전 받아오기
    const LATEST_VERSION = "v79.0";

    useEffect(() => {
        // 1) RN 에게 앱 버전 요청
        try {
            postToApp({ type: "GET_APP_VERSION" });
        } catch (e) {
            console.warn("GET_APP_VERSION postToApp 실패:", e);
        }

        // 2) RN → Web 응답 리스너
        const off = addAppMessageListener((msg) => {
            console.log("[APP_MSG]", msg);

            if (msg?.type !== "APP_VERSION") return;

            const raw = msg?.payload?.app_version ?? msg?.app_version ?? "unknown";

            // "0.10.03" 형식이면 v 붙여주기
            const v = raw.startsWith("v") ? raw : `v${raw}`;

            setAppVersion(v);
        });

        // 3) 클린업
        return () => off?.();
    }, []);


    const [channelCounts, setChannelCounts] = useState({
        kakao: 0,
        instagram: 0,
        blog: 0,
        mms:0,
        band: 0,
        x:0,
    });


    useEffect(() => {
        const sendGenerateRequest = async () => {
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/get/user/info`,
                    { userId },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                )
                if (response.data.info) {
                    setInfo(response.data.info);
                    setRegisterTag(response.data.info.register_tag)
                    try {
                        const tag = String(response.data.info.register_tag || "").trim();
                        if (tag) localStorage.setItem("registerTag", tag);
                        else localStorage.removeItem("registerTag");
                    } catch {
                        // ignore
                    }
                }

                const { ticket_name, token_amount, billing_cycle } = response.data.ticket_info;
                setTicketInfo({ ticket_name, token_amount, billing_cycle });
                // console.log(response.data)

                const rawRecords = response.data.record || [];
                const normalized = Array.isArray(rawRecords) ? rawRecords : [rawRecords];
                setRecords(normalized);

                const counts = { kakao: 0, instagram: 0, blog: 0, band: 0, x:0 };
                normalized.forEach((rec) => {
                    switch (rec.channel) {
                        case 1:
                            counts.kakao += 1;
                            break;
                        case 2:
                        case 3:
                            counts.instagram += 1;
                            break;
                        case 4:
                            counts.blog += 1;
                            break;
                        case 5:
                            counts.mms += 1;
                            break;
                        case 6:
                            counts.band += 1;
                            break;
                        case 7:
                            counts.x += 1;
                            break;
                        default:
                            console.warn("알 수 없는 채널 값:", rec.channel);
                            break;
                    }
                });
                setChannelCounts(counts);
            } catch (error) {
                console.error("자동화 광고 생성 중 오류:", error);
                alert("광고 생성에 실패했습니다. 다시 시도해주세요.");
            }
        };
        sendGenerateRequest();
    }, [userId]);

    useEffect(() => {
        let alive = true;
        (async () => {
            const [menus, conciergeData] = await Promise.all([
                fetchSiksinMenusByBusinessNumber(storeBusinessNumber),
                fetchConciergeImagesByBusinessNumber(storeBusinessNumber),
            ]);
            if (!alive) return;
            const conciergeMenus = [
                conciergeData?.menu1,
                conciergeData?.menu2,
                conciergeData?.menu3,
            ]
                .map((v) => String(v ?? "").trim())
                .filter(Boolean);
            const effective = getEffectiveRepresentativeMenus({
                storeBusinessNumber,
                dbMenus: Array.isArray(menus) ? menus : [],
                conciergeMenus,
                registerTag,
            });
            setRepresentativeTop3(
                Array.isArray(effective) ? effective.slice(0, 3) : []
            );
        })();

        return () => {
            alive = false;
        };
    }, [storeBusinessNumber, registerTag]);

    const handleCalendar = () => {
        navigate("/mycalendar", {
            state: {
                storeBusinessNumber,
                tab, from
            },
        })// 캘린더로 이동
    };

    const handleToNoticeList = () => {
        saveMyPageScrollTarget("help");
        navigate('/ads/notice', { state: { storeBusinessNumber, fromTab: 'mypage', noticeFilter: "normal" } });  // 목록 페이지로 이동
    };

    // const handleTokenUsage = () => navigate("/token/usage", { state: { storeBusinessNumber } });
    // const handleCustomerSupport = () => alert("고객센터 연결 예정");
    // const handleEmail = () => window.location.href = "mailto:support@example.com";

    const handleFAQ = () => {
        saveMyPageScrollTarget("support");
        navigate('/ads/faq', { state: { storeBusinessNumber } });  // 목록 페이지로 이동
    };
    const handleInquiry = () => {
        saveMyPageScrollTarget("support");
        const name = info?.name
        const phone = info?.phone
        navigate('/ads/inquiry', { state: { name, phone } });  // 목록 페이지로 이동
    };
    const handleCallcenter = () => {
        saveMyPageScrollTarget("support");
        navigate('/ads/callcenter', { state: { storeBusinessNumber } });  // 목록 페이지로 이동
    };
    const handleSettings = () => {
        saveMyPageScrollTarget("help");
        navigate('/setting', { state: { userId } })
    }
    // 토큰 구매 탭
    const movePurchaseToken = () => {
        saveMyPageScrollTarget("token");
        navigate("/myticket", { state: { tab: "token" } });
    };

    const movePurchaseTokenNoScroll = () => {
        navigate("/myticket", { state: { tab: "token" } });
    };

    // 결제 내역 탭
    const movePurchaseHistory = () => {
        saveMyPageScrollTarget("token");
        navigate("/myticket", { state: { tab: "history" } });
    };
    // 토큰 사용 내역 탭
    const moveMyUsageHistory = () => {
        navigate("/usage/history", { state: { tab: "history" } });
    };

    // const handleSettings = () => navigate("/settings");
    const handleTerms = () => { saveMyPageScrollTarget("policy"); navigate("/ads/policy", { state: { type: "terms" } }) };
    const handlePrivacy = () => { saveMyPageScrollTarget("policy"); navigate("/ads/policy", { state: { type: "privacy" } }) };
    const handlePermission = () => { saveMyPageScrollTarget("policy"); navigate("/ads/policy", { state: { type: "permission" } }) };


    const tokenPayment = [
        { label: "토큰 구매", onClick: movePurchaseToken },   // 필요 시 추가
        { label: "결제 내역", onClick: movePurchaseHistory },
    ];

    const supportItems = [
        { label: "자주 묻는 질문", onClick: handleFAQ },
        { label: "1:1 문의", onClick: handleInquiry },   // 필요 시 추가
        { label: "고객센터", onClick: handleCallcenter },
    ];

    const termsItems = [
        { label: "서비스 이용약관", onClick: handleTerms },
        { label: "개인정보처리방침", onClick: handlePrivacy },
        { label: "접근 권한", onClick: handlePermission }, // 필요 없으면 제거
    ];

    const helpItems = [
        { label: "공지사항", onClick: handleToNoticeList },
        { label: "환경설정", onClick: handleSettings },   // 필요 시
    ];

    const Section = ({ title, items, id }) => {
        const isTokenSection = id === "token";

        return (
            <div className="pb-[24px]" id={id}>
                {/* 섹션 제목 */}
                <div className={`w-full text-t4 text-text-subtle pt-[24px] pb-[8px]  ${isTokenSection ? "" : "border-t border-border-subtle"}`}>
                    {title}
                </div>

                {/* 섹션 안 리스트 */}
                <ul className="text-b1 text-text-subtle">
                    {items.map((item, idx) => (
                        <li key={idx}>
                            <button
                                onClick={item.onClick}
                                className="w-full text-text-subtle flex justify-between items-center py-[16px]"
                            >
                                <span>{item.label}</span>
                                <img src={right} alt="" />
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        )
    };


    // 공통: 세션/스토리지 초기화 유틸(파일 상단 가까운 곳에 한 번 정의하고 두 군데서 호출)
    function resetClientSessionForRegister() {
        try {
            // axios 헤더 제거
            if (axios?.defaults?.headers?.common?.Authorization) {
                delete axios.defaults.headers.common.Authorization;
            }
        } catch { }

        // 자동 로그인/상태류
        // localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("user_id");
        localStorage.removeItem("store_business_number");

        // KCB/PASS 흐름 재개 방지 플래그
        sessionStorage.removeItem("kcb_starting");
        sessionStorage.removeItem("kcb_done");
        sessionStorage.removeItem("kcb_enc");

        // 예전 네이버 콜백 값 정리
        sessionStorage.removeItem("naver_oauth_state");
        sessionStorage.removeItem("naver_redirect_uri");
    }



    const handleLogout = async () => {
        // if (!window.confirm("정말 로그아웃하시겠습니까? ")) return;

        const payload = { user_id: userId };

        try {

            const response = await axios.post(
                `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/user/logout`,
                payload,
                { headers: { "Content-Type": "application/json" } }
            );

            const ok = response?.data?.success === true;


            if (ok) {
                // RN에서 Firebase/Google signOut 처리}
                try { postToApp({ type: "START_SIGNOUT" }) } catch { }
                resetClientSessionForRegister();


                // 3) 라우팅 복귀
                navigate("/ads/register?step=1&auth=login", { replace: true });
            }
            else {
                const msg = response?.data?.message || "로그아웃 처리에 실패했습니다. 잠시 후 다시 시도해주세요.";
                alert(msg);
            }
        }
        catch (error) {
            // 서버가 200 외 상태코드를 준 경우
            if (error?.response) {
                const apiMsg =
                    error.response?.data?.detail ||
                    error.response?.data?.message ||
                    "서버 오류가 발생했습니다.";
                alert(apiMsg + ` (코드: ${error.response.status})`);
            }
            // 요청은 갔지만 응답이 없는 경우(네트워크/타임아웃)
            else if (error?.request) {
                alert("네트워크 오류로 탈퇴 요청에 실패했습니다. 인터넷 연결을 확인한 후 다시 시도해주세요.");
            }
            // 그 외 런타임 에러
            else {
                alert("알 수 없는 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
                console.error("탈퇴 처리 중 오류:", error);
            }
        }
    };



    const moveMyInfo = () => {
        navigate("/myInfo", { state: { info, roadName, data } });
    };

    const moveCancelUser = () => {
        saveMyPageScrollTarget("token");
        navigate("/cancel/user", { state: { storeBusinessNumber, ticketInfo } });
    };

    const infoRows = [
        { label: "가게 이름", value: data.store_name || "" },
        { label: "가게 주소", value: roadName || "" },
        { label: "대표자 이름", value: data.business_name || "" },
        {
            label: "대표 메뉴",
            value:
                representativeTop3.length > 0
                    ? representativeTop3.join(", ")
                    : "없음",
        },
    ];


    return (
        <div className="w-full">
            <div
                ref={headerRef}
                className="fixed top-0 left-0 right-0 z-20"
            >
                <HeaderIconL
                    title="내 매장"
                />
            </div>
            <div
                className="fixed left-0 right-0 bottom-0 overflow-y-auto bg-bg-white overscroll-contain"
                style={{ top: headerSpace }}   // headerSpace(px) 만큼 아래에서 시작
            >
                <div className="p-[16px]" style={{ paddingBottom: "68px" }}>

                    {/* 매장 정보 */}
                    <div className="border-b border-border-subtle pb-[16px]">
                        <div className="flex justify-between pt-[16px]">
                            <div className="text-t2">{business_name}님</div>
                            <button className="underline text-b2 text-text-subtler" onClick={moveMyInfo}>내 정보 수정</button>
                        </div>
                        <div className="text-c2 text-text-subtler py-[16px]">
                            {loginIconSrc && (
                                <img
                                    src={loginIconSrc}
                                    alt={`${loginLabel} 로그인`}
                                    className="inline-block w-[16px] h-[16px] mr-[4px]"
                                />
                            )}
                            {loginLabel} 로그인
                        </div>
                    </div>

                    <div className="pt-[16px] pb-[8px]">
                        <div className="border-b border-border-subtle pb-[32px]">
                            <h2 className="text-t4 text-text-subtle pb-[16px]">내 매장 정보</h2>
                            <div className="w-full rounded-[16px] border border-border-subtle bg-bg-white px-[12px]">
                                {infoRows.map((item, idx) => (
                                    <div
                                        key={item.label}
                                        className={`flex py-3 ${idx !== infoRows.length - 1 ? "border-b border-border-subtle" : ""
                                            }`}
                                    >
                                        {/* 왼쪽 라벨 */}
                                        <div className="w-28 shrink-0 text-sm text-gray-500">
                                            {item.label}
                                        </div>

                                        {/* 오른쪽 값 (줄바꿈 허용) */}
                                        <div className="flex-1 text-sm text-gray-900 leading-relaxed">
                                            {item.value}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* 보유 토큰 */}
                        <div className="border-b pb-8 pt-4 " >
                            <h2 className="text-t4 text-text-subtle pb-[16px]">내 이용권</h2>
                            <div className="bg-surface-light-subtle border-[1px] border-border-subtle rounded-[16px] p-[16px]">
                                <div className="flex flex-row gap-[16px] justify-between items-center cursor-pointer" onClick={moveMyUsageHistory}>
                                    <div className="flex flex-row">
                                        <img src={coin} alt="" className="pr-2" />
                                        <p className="text-b1 text-text-subtle">현재 보유 토큰</p>
                                    </div>
                                    <div className="flex flex-row">
                                        <p className="text-t4 text-text-primary">{ticketInfo.token_amount}개</p>
                                        <img src={right_gray} alt="" />
                                    </div>
                                </div>
                                {Number(ticketInfo?.token_amount ?? 0) < 1 && (
                                    <button
                                        className="text-center bg-btn-primary-fill mt-[14px] rounded-[16px] items-center justify-center flex w-full py-[8px]"
                                        onClick={movePurchaseTokenNoScroll}
                                    >
                                        <div className="text-text-inverse text-b2">
                                            <span>토큰 구매하기</span>
                                        </div>
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* 채널별 숫자 */}
                        <div className="pt-[16px] pb-[16px]">
                            <p className="text-text-subtle text-t4 pb-[16px] flex" onClick={handleCalendar}>공유된 채널
                                <img src={right} alt="" />
                            </p>
                            <div className="flex justify-around text-center rounded-[16px] border border-border-subtle">
                                <div
                                    className="flex-1 cursor-pointer text-text-subtler text-c2 py-[16px]"
                                    onClick={() =>
                                        navigate("/mycalendar", {
                                            // state: { title: "인스타그램", recordList: records, channelType: "instagram", tab, from },
                                            state: { tab, from, initialChannelFilter: "인스타그램", },
                                        })
                                    }
                                >
                                    인스타그램
                                    <p className="text-text-primary text-t3">{channelCounts.instagram}</p>
                                </div>

                                {/* 세로 구분선 */}
                                <div className="self-stretch border-l border-border-subtle" />

                                <div
                                    className="flex-1 cursor-pointer text-text-subtler text-c2 py-[16px]"
                                    onClick={() =>
                                        navigate("/mycalendar", {
                                            state: { tab, from, initialChannelFilter: "카카오톡", },
                                        })
                                    }
                                >
                                    카카오톡
                                    <p className="text-text-primary text-t3">{channelCounts.kakao}</p>
                                </div>

                                {/* 세로 구분선 */}
                                <div className="self-stretch border-l border-border-subtle" />

                                <div
                                    className="flex-1 cursor-pointer text-text-subtler text-c2 py-[16px]"
                                    onClick={() =>
                                        navigate("/mycalendar", {
                                            state: { tab, from, initialChannelFilter: "네이버 밴드", },
                                        })
                                    }
                                >
                                    네이버 밴드
                                    <p className="text-text-primary text-t3">{channelCounts.band}</p>
                                </div>
                                {/* 세로 구분선 */}
                                <div className="self-stretch border-l border-border-subtle" />

                                <div
                                    className="flex-1 cursor-pointer text-text-subtler text-c2 py-[16px]"
                                    onClick={() =>
                                        navigate("/mycalendar", {
                                            state: { tab, from, initialChannelFilter: "X(트위터)", },
                                        })
                                    }
                                >
                                    X(트위터)
                                    <p className="text-text-primary text-t3">{channelCounts.x}</p>
                                </div>
                                <div className="self-stretch border-l border-border-subtle" />

                                <div
                                    className="flex-1 cursor-pointer text-text-subtler text-c2 py-[16px]"
                                    onClick={() =>
                                        navigate("/mycalendar", {
                                            state: { tab, from, initialChannelFilter: "MMS(문자))", },
                                        })
                                    }
                                >
                                    MMS(문자)
                                    <p className="text-text-primary text-t3">{channelCounts.x}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex-1 bg-surface-light-subtle h-[16px] -mx-[16px]"></div>

                    {/* 이용권 정보 */}
                    <div className="w-full">
                        <Section title="토큰 · 결제" items={tokenPayment} id="token" />
                        <Section title="고객지원" items={supportItems} id="support" />
                        <Section title="서비스 이용약관/동의" items={termsItems} id="policy" />
                        <Section title="도움말" items={helpItems} id="help" />
                    </div>
                    {/* 버전 정보 */}
                    <div className="-my-[8px]">
                        <VersionInfo
                            currentVersion={appVersion}
                            latestVersion={LATEST_VERSION}
                        />
                    </div>



                    {/* <div className="flex-1 border-border-subtle py-1 px-6"></div> */}
                    <div
                        className="flex justify-center items-center text-b1 text-text-subtler py-[24px] gap-[8px]">
                        <button
                            type="button"
                            className="px-[2px] py-[6px] border-none bg-transparent"
                            onClick={() => setLogoutOpen(true)}
                        >
                            로그아웃
                        </button>

                        <span className="">・</span>

                        <button
                            type="button"
                            id="cancel"
                            className="py-[6px] border-none bg-transparent"
                            onClick={moveCancelUser}
                        >
                            회원 탈퇴
                        </button>
                        {logoutOpen &&
                            (<Popup
                                isOpen={logoutOpen}
                                onClose={() => setLogoutOpen(false)}
                                title="로그아웃하시겠습니까?"
                                subtitle={
                                    "서비스 첫 화면으로 이동합니다."
                                }

                                renderButtons={
                                    <>
                                        <TwinColumn
                                            topType={"fill"}
                                            topText={"네"}
                                            onTop={handleLogout}
                                            bottomType={"border"}
                                            bottomText={"아니요"}
                                            onBottom={() => setLogoutOpen(false)}
                                        />
                                    </>
                                }
                            />)
                        }
                    </div>
                </div>

            </div>
        </div>
    );
};

export default MyPage;
